import React, { useState } from "react";

import { hasPermission } from "../../../services/auth";
import ModalPurchaseOrder from "../ModalPurchaseOrder";
import ModalPurchaseOrderForm from "../ModalPurchaseOrderForm";

/**
 * Detalhe do pedido de compra com a edição a partir dele. É o mesmo par na
 * lista de compras e no pedido de venda, para mexer na compra sem sair do
 * pedido.
 */
export const PurchaseOrderModals = ({ purchaseOrder, close, onChanged }) => {
    const [editing, setEditing] = useState(null);

    return (
        <>
            <ModalPurchaseOrder
                show={purchaseOrder !== null}
                close={close}
                purchaseOrder={purchaseOrder}
                canManage={hasPermission('manage_purchase_order')}
                onChanged={onChanged}
                onEdit={purchase => {
                    close();
                    setEditing(purchase);
                }}
            />

            <ModalPurchaseOrderForm
                show={editing !== null}
                close={() => setEditing(null)}
                purchaseOrder={editing}
                onSaved={onChanged}
            />
        </>
    );
};

export default PurchaseOrderModals;
